import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createNote } from '../../api/notes'
import { QUERY_KEYS } from '../../constants/queryKeys'

function useCreatePartnerNote() {
   const queryClient = useQueryClient()
   return useMutation({
      mutationFn: createNote,
      onSuccess: (_, request) => {
         queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_PARTNER_NOTES, request.memberId] })
         queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_PARTNER_LATEST_NOTE, request.memberId] })
      },
   })
}

export { useCreatePartnerNote }
export default useCreatePartnerNote
